import { icons } from './icons';

export const projectName = 'ganamos'; // ACHTUNG: поменять под имя сайта

const rubySort = [
  'rp_192', // Gana Volcano
  'kg_5007', // 3 Big Barrels Aztec
  'rp_763', // Volcano Rising SE
  'kg_5001', //  Voltage Blitz Vortex
  'kg_5009', // Voltage Blitz Rapid
  'rp_558', // Volcano Rising
  'kg_5002', // Celestial Flame Coin Rise
  'rp_555', // Zeus Rush Fever Deluxe
  'rp_757', // Vegas No Limit Wins SE
  'rp_507', // Vegas No Limit Wins
  'rp_510', // Rush Fever 7s Deluxe
  // Elephant Stampede SE - нету
  // Diamond Explosion 7s SE - нету
  'rp_501', // Mayan Cache
  'rp_589', // Stampede Rush Trident
  'rp_522', // Shake Shake Money Tree
  'rp_42', // Elephant Stampede
  'rp_28', // Egyptian Sun
  'rp_38', // Zeus Rush Fever
  // Go High Joker - нету
  'rp_15', // Brilliant Gems
  'rp_44', // Rush Fever 7s
  'rp_744', // Immortal Ways Cleopatra
  'rp_504', // Diamond Explosion 7s
  'rp_687', // Gummy Giga Match
  'rp_622', // J Mania Golden Eggs
  'rp_76', // Native Spirit
  'rp_20', // Loco Habanero
  'rp_736', // Immortal Ways Buffalo SE
  // Immortal Ways Diamonds SE - нету
  'rp_642', // Go High Panda
  'rp_791', // Giga Match Bunny
  'rp_794', // Immortal Ways Gallina Harvest
  'rp_667', // Immortal Ways Diamonds (Easter)
  'rp_670', // Mad Hit Wild Alice (Easter)
];

const pragmaticRGSSort = [
  '7853',
  '32731',
  '14269',
  '13232',
  '13259',
  '13241',
  '53844',
  '7866',
  '7860',
  '55466',
  '44319',
  '22300',
  '20173',
  '47164',
  '21185',
  '48954',
  '13233',
  '41603',
  '7857',
  '50973',
];
const pragmaticSort = [
  'vs5joker',
  'vs5jokerdice',
  'vs25goldparty',
  'vsways5lions2',
  'vs432congocash',
  'vswaysbufking',
  'vswaysasiatrzn',
  'vs15diamond',
  'vswayschilheat',
  'vsways5lionsr',
  'vs20sugarrushx',
  'vs40cosmiccash',
  'vs20mustanggld2',
  'vs20fruitswx',
  'vs10txbigbass',
  'vs25mustang',
  'vs25rio',
  'vs20olympx',
  'vs5aztecgems',
  'vs25checaishen',

  // xMas
  'vs20sbxmas',
  'vs20sugrux',
  'vs10bbxext',
  'vs10bxmasbnza',
  'vs12bbbxmas',
  'vs10bbsplxmas',
  'vs20schristmas',
  'vs20xmascarol',
  'vs25xmasparty',
  'vs10ddcbells',
  'vs20leprexmas',
  'vs20santa',
  'vs20porbs',
  'vs20santawonder',
];

const KAGamingSort = [
  // desktop
  '638f05823691435c84a66354a707924b', // "Hot Coin"
  '1aed5aff45034535856144ccd029b1c7', // "Red Sorghum"
  '553000ad92ff4b7aa73eac11622b1616', // "Irish Coins"
  '929db10eb2af4269a2a49b22101dfc41', // "Red Riding Hood"
  '4c9c52aa1f1149aca2e07ab36703910e', // "777 Vegas"
  'cc35f1e4506945c7b4c4a43841652228', // "Scary Clown"
  'c019dfb6372f46b0982f1d1651968610', // "Lady KAKA"
  '0b1081c6ea174d8e884a7ae1062ed30d', // "Tai Chi"
  'f7782554f02240b49f5e1af8152c2671', // "Fruit Party"
  '864875af5a0841dc85187895179dd3aa', // "Cash Coming"

  // '9770853e59964ab69eb13eaaf3d6fb58',
  // '95142725da864976a416312124a3fc72',
  // '674ffdd452f8486c936158c19b22b477',
  // '83980719600d4ff89407ef1da44aea15',
  // '98df7821998244889ed4e0fb574081b2',

  // xMas
  '1b7c704fb9724c36b72da9301232589d',
  '4981bee599d2406c8a5fb23528b06f47',

  // mobile
  '3331dc006cd645d387e2756554efc558', // "Hot Coin"
  '99233ebed020400d9354d6d7ac68abec', // "Red Sorghum"
  '871af472448a4834af8dec8f3dd25095', // "Irish Coins"
  '74596d7affcb434090b523c8009f2c5b', // "Red Riding Hood"
  'ddc560b77ea9457fae0ebd9b44f97dc2', // "777 Vegas"
  'fff4e44c5f974323bec49de632ec4950', // "Scary Clown"
  'e9fd361c8ce046e7a5d1027414d3b9c6', // "Lady KAKA"
  '0ce2daad8f984f6d8836088cb23af191', // "Tai Chi"
  '5ba72166ebb64b069a7430a6dfe621a6', // "Fruit Party"
  'e23dd002ff84446685dc331ea9b02425', // "Cash Coming"

  // 'b98aa59554a94cf0b96d91df9b0428bf',
  // '4cc669ac922849d19c8a2d0442e5dde3',
  // '96242433aedd472cb1b32339244ac1ac',
  // '0ca939bed417491595a9b7598a807eda',
  // '4d0a32bb3af2447cb975324286a39c4c',

  // xMas
  'f5d5570495c34b0e977a0c3e5c28dc09',
  '7684cd0a7d52429e9d826c847c0e972f',
];

const netentSort = ['gonzos_quest_touch', 'super_stars', 'busters_bones', 'king_of_slots_html', 'victorious_touch'];

const booongoSort = [
  'fruity_wild_bng_html',
  'star_gems_bng_html',
  'singles_day_bng_html',
  'sky_gems_5_wilds_bng_html',
  'vikings_winter_bng_html',
];

const amaticSort = [
  'luckyjoker5_original',
  'allwaysjoker_original',
  'enchantedcleopatra_original',
  'lucky_coin_original',
  'rouletteroyal_original',
];

const microgamingSort = [
  'luckyleprechaun_mg_html',
  'fortunium_mg_html',
  'halloweenies_mg_html',
  'suntide_mg_html',
  'wildscarabs_mg_html',
  'luckytwins_mg_html',
  'bustthebank_mg_html',
  'loaded_mg_html',
];

const playngoSort = ['firejoker_png', 'riseofolympus_png', 'moonprincess_png', 'infernostar_png', 'reactoonztwo_png'];

const redrakeSort = [
  'bsw-egypt', // Mysteries of Egypt
  'bsw-tumbling-diamonds', // Queens & Diamonds
  'bsw-super5stars', // Super 5 Stars
  'bsw-dragonfortunes', // The Legendary Red Dragon
  'bsw-rlt_european', // "European Roulette"
  'bsw-guardianofra', // Guardian of Ra
  'bsw-jokerfiesta', // Joker Fiesta
  'bsw-medusahunt', // Medusa Hunt
];

const igtSort = [
  'cleopatra_igt_html',
  'cats_igt_html',
  'triplediamondskb_igt_html',
  'wolfrun_igt_html',
  'treasuresofthepyramidsskb_igt_html',
];

const aristocratSort = [
  'buffalo',
  'tiki_torch',
  'flame_of_olympus',
  'lucky_count',
  'double_happiness',
  'fire_light',
  'queen_of_the_nile_2_html',
  'lucky_88_html',
];

const belatraSort = [
  'mummyland_ganamos', // Ganamos Treasures
  'miner', // Jackpot Mines
  'mummyland', // MummyLand Treasures
  'fishing', // Blast the Bass
  'buffalo', // Big Wild Buffalo
  'joker', // Lavish Joker
];

const platipusSort = [
  'azteccoins',
  'catchtheleprechaun',
  'frozenmirror',
  'pirateslegacy',
  'piratesmap',
  'jackpotlab',
  'wildspindeluxe',
  'aztectemple',
  'leprechauns',
  'luckycat',
  'wildspin',
  'thousandonespins',
  'chinesetigers',
  'hotfruits',
  'wildcrowns',
  'thebigscore',
  'caishensgifts',
  'santasbag',
  'bookofegypt',
];

const upgamingSort: number[] = [
  79710, 79712, 79713, 79714, 79715, 79716, 79717, 79718, 79719, 79720, 79721, 79722, 79723, 79727, 80117, 80161, 82469,
  82470, 82471, 82472, 82481, 82484, 84720,
];

const hpSort = [
  '0197c5b6-1223-7cbe-b72e-374167c68e7e', // Astronaut
  '0197c5b6-06de-7a5d-b84d-33b484b1cfe9', // StarX
  '0197c5b6-0b81-7062-8e6a-ae1e5c34c35b', // Fortune Crash
  '0197c5b6-189b-78ff-9c60-a766cfc6430b', // Mines
  '0197c5b6-0dc6-71c1-916c-ed3ed0afa7bd', // Tropicana
];

const popokgamingSort: number[] = [
  249,
  702, // Ganamos Crash
  5, // 40 Lucky bell
  2, // Diamond Flash
  601, // Plinko
  711, // AVI
  12, // Mega Joker
  702, // Crash Infinty
  28, // Yummy Buy Feature
  4, // 20 Lucky bell
  125, // Royal Flash
  10, // 100 Lucky Bell
  615, // Mines
  37, // Lucky Patrick's Day
  174, // 777 Triple Sevens
  502, // Diamond Fruits
  149, // Mega Diamonds
];

const bgamingSort = [
  'WildTiger',
  'JokersMillion',
  'AztecMagicMegaways',
  'HotChilliBells',
  'BurningChilliX',
  'BonanzaBillion',
  'JokerQueen',
  'SnoopDoggDollars',
  'WildWestTrueways',
  'FruitMillion',
];

const amusnetSort = [
  '20364',
  '20003',
  '20029',
  '20013',
  '20281',
  '20174',
  '20045',
  '20282',
  '20142',
  // '20330',
  // '20343',
  '20381',
  '20033',
  '20086',
  '20129',
  // '20333',
  '20364',
  '20061',
  '20007',

  // '20331',
  // '20328',
];

export const halloweenProvidersSort: string[] = [
  'rubyplay',
  'pragmatic',
  'pragmatic-rgs',
  'belatra',
  'amatic',
  'apollo',
  'aristocrat',
  'booongo',
  'egt',
  'greentube',
  'hacksaw',
  'microgaming',
  'netent',
  'nolimit',
  'playson',
  'playngo',
  'wmg',
  'relaxgaming',
  'wazdan',
  'popokgaming',
];

export const halloweenSort: (string | number)[] = [
  'rp_853', // Mad Hit Devil (Ruby)
  'vs10bhallbnza3', // Big Bass Halloween 3 (vs10bhallbnza3) - Pragmatic
  'vswayspompmr2', // Zombie School Megaways - Pragmatic
  'digger_halloween', // Halloween Crystals - Belatra
  'halloween', // Halloween - Belatra
  'vs25wolfgold', // Wolf Gold (vs25wolfgold_prg) - Pragmatic

  'vswayswildbrst', // Witch Heart Megaways (vswayswildbrst)
  'vs20fatbook', // Book of Monsters (vs20fatbook)
  'vs10fangfree', // Fangtastic Freespins (vs10fangfree)
  'vs10bhallbnza2', // Big Bass Halloween 2 (vs10bhallbnza2)
  'vswayswbounty', // Vampy Party (vswayswbounty)
  'vs20mergedwndw', // Blade & Fangs (vs20mergedwndw)
  'vs10bhallbnza', // Big Bass Halloween (vs10bhallbnza)
  'vs40infwild', // Infective Wild (vs40infwild)
  'vs243nudge4gold', // Hellvis Wild™ (vs243nudge4gold)
  'vs20daydead', // Day of Dead™ (vs20daydead)
  'vs20magicpot', // The Magic Cauldron – Enchanted Brew (vs20magicpot)
  'vswaysmadame', // Madame Destiny Megaways™ (vswaysmadame)
  'vs40voodoo', // Voodoo Magic (vs40voodoo)
  'vs25walker', // Wild Walker (vs25walker)
  'vswayswerewolf', // Curse of the Werewolf Megaways™ (vswayswerewolf)
  'vs4096mystery', // Mysterious (vs4096mystery)
  'vs10vampwolf', // Vampires vs Wolves (vs10vampwolf)
  'vs10madame', // Madame Destiny (vs10madame)

  'digger_halloween', // Halloween Crystals - Belatra
  'halloween', // Halloween - Belatra
  'voodoo', // Voodoo Coins
  'fortune_mummy', // Fortune Mummy
  'mummyland', // MummyLand Treasures
  'mummy_mines', // Mummys Mines

  'wolf_moon_original', // Wolf Moon (wolf_moon_original)
  'bookoffruitshalloween_original', // Book of Fruits Halloween (bookoffruitshalloween_original)
  'blood_ag', // Blood (blood_ag)
  // Aristocrat
  'werewolf_wild_html', // Werewolf Wild (werewolf_wild_html)
  // Booongo
  'black_wolf_bng_html', // Black Wolf (black_wolf_bng_html)
  // EGT
  'witches_charm_html', // Witches Charm (witches_charm_html)
  // Greentube
  'thirteen_gt_html', // Thirteen (thirteen_gt_html)

  // Hacksaw
  '1116', // Halloween - Hacksaw

  // Microgaming
  'thephantomoftheopera_mg_html', // The Phantom of the Opera (thephantomoftheopera_mg_html)
  'halloween_mg_html', // Halloween (halloween_mg_html)
  'halloweenies_mg_html', // Halloweenies (halloweenies_mg_html)

  // NetEnt
  'phantom_of_the_opera', // Phantom of the Opera (phantom_of_the_opera)
  'frankenstein_touch', // Frankenstein (frankenstein_touch)
  'dracula_touch', // Dracula (dracula_touch)
  'mythic_maiden_touch', // Mythic Maiden (mythic_maiden_touch)
  'the_invisible_man', // The Invisible Man (the_invisible_man)
  'blood_suckers_touch', // Blood Suckers (blood_suckers_touch)
  'blood_suckers_2', // Blood Suckers 2 (blood_suckers_2)
  'dead_or_alive_html', // Dead or Alive (dead_or_alive_html)
  'halloween_jack', // Halloween Jack (halloween_jack)
  'dead_or_alive_2', // Dead or Alive 2 (dead_or_alive_2)
  'witchcraft_academy', // Witchcraft Academy (witchcraft_academy)

  'deadwood_nl', // Deadwood (deadwood_nl)
  'infectious5_nl', // Infectious 5 Ways (infectious5_nl)
  'mental_nl', // Mental (mental_nl)
  'tombstonerip_nl', // Tombstone R.I.P (tombstonerip_nl)

  'wolf_power_ps_html',

  // Playngo
  'happyhalloween_png', // Happy Halloween (happyhalloween_png)
  // WMG (Playtech)
  'hauntedhouserip_wmg', // Haunted House Rest In Paradise (hauntedhouserip_wmg)
  'hauntedhouse_wmg', // Haunted House (hauntedhouse_wmg)
  // Relaxgaming
  'deadmanstrail_rg', // Dead Man's Trail (deadmanstrail_rg)
  'deadriderstrail_rg', // Dead Riders Trail (deadriderstrail_rg)
  // Wazdan
  'hh_wzdn', // Haunted Hospital (hh_wzdn)

  // POPOK
  '709', // Halloween Crash
];

const gambitSort = [
  '65fab425bf40138cb33f9bb3', // Fortune Numbers
  '68a56d412109f3ba4c28aaf6', // Legends Of Aztecs
  '675c1babf04931bfc045db2a', // Magic Pipes
  '6834566c6d43fff7b5987076', // Bang! Bang!
  '67dd5e7cbb21c87f57a4ff95', // Gems Of Olympus
  '685913f06d43fff7b5988572', // Coin Odyssey
  '68de84cbd3105b918d6c2f6e', // Arcane Burst
  '668e75089800052faac7bf29', // Random Rooms
  '68b82394ad06767dc48f733b', // Book of Zombies
];

const winspinitySort = [
  '66b9c4329165e4d6f9e97c4e', // Cash Me If You Can
  '681a0e724d306145e69eb433', // Tower of Luck
  '689992572109f3ba4c28a695', // Cash Me Eva
  '689c35184d0d6a4a33fcb20c', // Siren's Fortune
  '66f53ba942580d4c67ed966b', // Gilded Rhino
  '67b5bfbf62782fc671cbcb40', // Magic Packs
  '684ff64c6d43fff7b5987fac', // Payball
  '673af4ad42338185accb8395', // Condom Hub
  '668e71c4421c5d7130b74891', // Legacy of Phoenix
  'Pyramid Stakes', // Pyramid Stakes
  '668e71cf3a38602b14193e2c', // Moonlight Burst Max
  '68d67ac1d3105b918d6c2d29', // Cabaret Roulette
  '686bdf062109f3ba4c2883ce', // Western Heist
];

export const slotsSortArray: (string | number)[] = [
  ...rubySort,
  ...pragmaticSort,
  ...pragmaticRGSSort,
  ...KAGamingSort,
  ...bgamingSort,
  ...belatraSort,
  ...booongoSort,
  ...igtSort,
  ...netentSort,
  ...amaticSort,
  ...microgamingSort,
  ...playngoSort,
  ...redrakeSort,
  ...aristocratSort,
  ...platipusSort,
  ...hpSort,
  ...upgamingSort,
  ...popokgamingSort,
  ...amusnetSort,
  ...gambitSort,
  ...winspinitySort,
];

export const sortByCategories: Record<string, string[]> = {
  nuevo: ['long_neck'],
};

export const providersSortArray = [
  'all',
  'favorite', // ACHTUNG: закоментить если не нужны фавориты в провайдерах
  'rubyplay',
  'pragmatic',
  'pragmatic-rgs',
  'belatra',
  'amigogaming',
  'amusnet',
  'igt',
  'KAGaming',
  'bgaming',
  'bluejack',
  'betongames',
  'gambit',
  'winspinity',
  'netent',
  'redrake',
  'platipus',
  'booongo',
  'playson',
  'hacksaw',
  'playngo',
  'amatic',
  'microgaming',
  'aristocrat',
].map(provider => provider.toLowerCase());

export const crashProvidersSortArray = ['all', '100hp', 'upgaming'];

export const typesOfGames = [
  { value: 'all', name: 'all' },
  { value: 'favorite', name: 'favorite' }, // ACHTUNG: закоментить если не нужны фавориты в категориях
  { value: 'nuevo', name: 'nuevo' },
  { value: 'popular', name: 'popular' },
  { value: 'roulette', name: 'roulette' },
  { value: 'lotto', name: 'lotto' },
  { value: 'cardGames', name: 'card games' },
  // { value: 'slotMachines', name: 'slot machines' },
];

export const virtualProviders: string[] = ['universalrace'];

export const filteredProviders: string[] = [
  // ACHTUNG: ненужные провайдеры
  /* 'bgaming', 'macawgaming' */
  // 'macawgaming',
  '',
].map(provider => provider.toLowerCase());

export const sectionList = [
  {
    icon: icons.all,
    value: 'all',
  },
  //  {
  //   icon: icons.halloween,
  //   value: 'halloween',
  // },
  {
    icon: icons.favorite,
    value: 'favorite',
  },
  // {
  //   icon: icons.merryChristmas,
  //   value: 'xMas',
  // },
  {
    icon: icons.nuevo,
    value: 'nuevo',
  },
  {
    icon: icons.popular,
    value: 'popular',
  },
  {
    icon: icons.roulette,
    value: 'roulette',
  },
  {
    icon: icons.slotMachines,
    value: 'slotMachines',
  },
  {
    icon: icons.cardGames,
    value: 'cardGames',
  },
  {
    icon: icons.lotto,
    value: 'bingo',
  },
];

export const newGamesSort = [
  // pragmatic
  'vs5luckydogly',
  'vsways5lionsr',
  'vs10fortnhsly',
  'vs9ridelightng',
  'vs10booklight',
  'vs20lightblitz',
  'vs10forwildly',
  'vs5luckytigly',
  'vs20fatbook',
  'vs20dhsuper',
  'vs10fortnpig',
  'vswaysmodfr',
  'vswayssavlgnd',
  'vs12bgrbspl',
  'vs10fireice',
  'vswaysaztec',

  // belatra
  'mummy_mines',
  'chinese_panda',
  'cafe_50s',
  'make_gold',
  'fishing',

  // redrake
  'bsw-luxorguardians3',
  'bsw-cleoteam',
  'bsw-hawaiitopia',
  'bsw-spacewins',

  // platipus
  'fafnirskey',
  'sevensfruitfiesta',
  'lootnload',
  'hookthecash',
  'eveofgifts',
  'europeanblackjackmultihand',

  // rubyplay
  'kg_5001',
  'rp_772',
  'rp_811',
  'rp_804',
  'rp_797',
];

export const crashSort = [
  702, // Ganamos Crash
];
